module.exports = __webpack_public_path__ + "static/media/18ECA48.c73d3691.jpg";